// extracted by mini-css-extract-plugin
module.exports = {"labels":"e2ff468f85--labels--CSBtO","label":"e2ff468f85--label--ZZtW3","icon":"e2ff468f85--icon--KC9ew"};